export function initClickOutside(domEl, func) {
	const clickOutside = (e) => {
		const path = e.composedPath();
		if (!path.includes(domEl)) {
			func();
			document.removeEventListener('click', clickOutside);
		}
	};
	document.addEventListener('click', clickOutside);
	return clickOutside;
}
export function removeClickOutside(fn) {
	document.removeEventListener('click', fn);
}
